import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";
import * as homeReducer from "containers/Home/reducer";

import Optimization from "components/Business/Optimization/Optimization";
import NextOptimization from "components/Next/Optimization/Optimization";

class OptimizationContainer extends React.PureComponent {
  render() {
    return this.props.isNext ? <NextOptimization {...this.props} /> : <Optimization {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  return {
    initRun: () => {},
    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue)),
    updateUsePercentages: (value) => dispatch(projectReducer.updateUsePercentages(id, value)),
    updateApplyOverall: (value) => dispatch(projectReducer.updateApplyOverall(id, value)),
    updateBusinessMode: (businessMode) => dispatch(businessReducer.updateBusinessMode(id, businessMode)),
    updateUsePercentages: (value) => dispatch(projectReducer.updateUsePercentages(id, value)),
    introspectCountsFromData: (runId, column, successValue) =>
      dispatch(setupReducer.introspectCountsFromData(runId, column, successValue)),
    updateMadLibs: (runId, key, value) => dispatch(setupReducer.updateMadLibs(runId, key, value))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  const innerId = projectReducer.getInnerId(state, id);
  const runId = innerId ? innerId : id;

  const datasetId = setupReducer.getDatasetId(state, runId);

  return {
    id: id,
    runId: runId,
    setup: setupReducer.getSetup(state, runId),
    fields: homeReducer.getFields(state, datasetId),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    setupLabels: setupReducer.getSetupLabels(state, runId),

    project: projectReducer.getProject(state, id),
    modelGroups: projectReducer.getModelGroups(state, id, true),
    businessMode: businessReducer.getBusinessMode(state, id),
    hasBusinessSetup: projectReducer.getHasBusinessSetup(state, id),
    dataset: homeReducer.getDataset(state, datasetId),
    isOverallSegment: projectReducer.getIsOverallSegment(state, id, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OptimizationContainer);
